export default __webpack_public_path__ + "static/media/area-12.702aab34.jpg";